"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import ExchangeTaskEntry from './ExchangeTaskEntry'

interface ContractExchangeProps {
  campaignId: string
  task: AutopilotTaskDto
}

const ContractExchange = ({ campaignId, task }: ContractExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeContractExchangeBtn"
    campaignId={campaignId}
    panelKey="ContractExchangePanel"
    task={task}
    title="Contract Exchange"
  />
)

export default ContractExchange
